<template>
  <header :class="$style.PFChatHeader">
    <div :class="$style.PFChatHeaderAvatarCtx">
      <img
        :src="avatar"
        alt=""
        :class="$style.PFChatHeaderAvatar"
      >
      <div :class="$style.PFChatHeaderAvatarLabel">
        <span :class="$style.PFChatHeaderOperatorName">
          {{ operatorName }}
        </span>
        <span :class="$style.PFChatHeaderStatus">
          Online
        </span>
      </div>
    </div>

    <div :class="$style.PFChatHeaderCloseCtx">
      <button :class="$style.PFChatHeaderCloseButton">
        <CloseRounded :class="$style.PFChatHeaderCloseButtonIcon" />
      </button>
    </div>
  </header>
</template>

<script>
/**
 * Static
 */
import CloseRounded from '@/assets/icons/CloseRounded.svg?inline'

export default {
  components: {
    CloseRounded
  },
  props: {
    avatar: {
      type: String,
      default: null
    },
    operatorName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style module lang="scss">
.PFChatHeader {
  all: unset;
  box-sizing: border-box;
  position: sticky;
  z-index: 9;
  top: 0;
  left: 0;
  width: 100%;
  padding: calc(24px * var(--pf-chat-scale));
  background-color: var(--pf-chat-whatsapp-background);
  display: flex;
  justify-content: space-between;
  gap: calc(16px * var(--pf-chat-scale));
}

.PFChatHeaderAvatarCtx {
  all: unset;
  display: flex;
  gap: calc(8px * var(--pf-chat-scale));
  align-items: center;
  width: calc(100% - calc(40px * var(--pf-chat-scale)));
}

.PFChatHeaderCloseCtx {
  all: unset;
  flex-shrink: 0;
}

.PFChatHeaderAvatar {
  --s: calc(40px * var(--pf-chat-scale));

  all: unset;
  display: flex;
  width: var(--s);
  height: var(--s);
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  overflow: hidden;
}

.PFChatHeaderAvatarLabel {
  all: unset;
  display: flex;
  flex-direction: column;
  gap: calc(4px * var(--pf-chat-scale));
  width: calc(100% - calc(40px * var(--pf-chat-scale)));
}

.PFChatHeaderOperatorName {
  all: unset;
  display: inline;
  font-family: 'Roboto', sans-serif !important;
  font-style: normal;
  font-weight: 500;
  font-size: calc(16px * var(--pf-chat-scale));
  line-height: calc(19px * var(--pf-chat-scale));
  letter-spacing: -0.3px;
  color: #000;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.PFChatHeaderStatus {
  all: unset;
  display: inline;
  font-family: 'Roboto', sans-serif !important;
  font-style: normal;
  font-weight: 400;
  font-size: calc(12px * var(--pf-chat-scale));
  line-height: calc(16px * var(--pf-chat-scale));
  color: #8e8e93;
}

.PFChatHeaderCloseButton {
  all: unset;
  display: flex;
  cursor: pointer;
}

.PFChatHeaderCloseButtonIcon {
  --s: calc(24px * var(--pf-chat-scale));

  all: unset;
  display: flex;
  width: var(--s);
  height: var(--s);
  color: var(--disabled);
}
</style>
